function LogoRow({ items, ariaHidden = false }) {
  return (
    <span aria-hidden={ariaHidden || undefined} className="flex items-center gap-14 md:gap-20">
      {items.map((l) => (
        <span key={`${ariaHidden ? "dup-" : ""}${l.id}`} className="flex h-14 w-36 shrink-0 items-center justify-center md:h-16 md:w-44">
          <img
            src={l.image}
            alt={l.name || "Client logo"}
            loading="lazy"
            className="h-full w-auto max-w-full object-contain grayscale opacity-70 transition-[filter,opacity] duration-500 hover:grayscale-0 hover:opacity-100"
          />
        </span>
      ))}
    </span>
  );
}

export default function LogoMarquee({ items, label, testid = "client-logo-marquee" }) {
  if (!items?.length) return null;
  return (
    <section aria-label={label} data-testid={testid} className="border-y border-ash bg-paper py-10 md:py-12">
      {label && (
        <p className="mx-auto mb-8 max-w-[1440px] px-5 text-[13px] font-bold uppercase tracking-[0.2em] text-slategray md:px-10 md:text-sm">{label}</p>
      )}
      <div className="relative overflow-hidden">
        <div className="flex w-max animate-marquee items-center gap-14 pr-14 md:gap-20 md:pr-20">
          <LogoRow items={items} />
          <LogoRow items={items} ariaHidden />
        </div>
      </div>
    </section>
  );
}
